import React, { Component, lazy, Suspense } from "react";
// import { Link } from "react-router-dom";
import { bannerMonitoredData } from "../../actions/common.action";
import People from "../../assets/frontPageIcons/people.png";
import System from "../../assets/frontPageIcons/system.png";
import { formatNumberOnDashBoard } from "../../helper";
// import { get } from "lodash";
import PmgModal from "./PmgModal";
import PmgMechanismModal from "./PmgMechanismModal";
import PmgTeamModal from "./PmgTeamModal";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import ReactPlayer from "react-player";
import screenfull from "screenfull";
import { findDOMNode } from "react-dom";
import CountUp from "react-countup";
const ReactPlayer = lazy(() => import("react-player"));

class BannerResponsive extends Component {
  videoUrl = "https://www.youtube.com/embed/OjK8eKfEhco";
  // videoUrl = "https://www.youtube.com/embed/wtjB3CCfvoY";

  state = {
    monitoredData: {},
    isBannerModalVisible: false,
    bannerContent: "",
    pauseVideos: false,
    muted: true,
    loop: 1,
    videoArr: Array(1).fill(this.videoUrl),
    updateValues: 0,
    _isMounted: false
  };

  componentDidMount() {
    window && window.addEventListener("scroll", this.onScroll);
    this.setState({ _isMounted: true });
    this.getBannerMonitoredData();
  }

  onScroll = () => {
    let currentOffset = (window && window.scrollY) || 0;
    if (
      (currentOffset > 75 && currentOffset < 110) ||
      (currentOffset > 710 && currentOffset < 736)
    ) {
      this.setState({
        updateValues: Math.random()
      });
    }
  };

  getBannerMonitoredData = async () => {
    let response = await bannerMonitoredData();
    if (response && response.status && this.state._isMounted) {
      this.setState({ monitoredData: response.data.data });
    }
  };

  closeReadBannerModal = () => {
    this.setState({ isBannerModalVisible: false, bannerContent: "" });
  };

  showReadBannerModal = key => {
    this.setState({ isBannerModalVisible: true, bannerContent: key });
  };

  onClickFullscreen = () => {
    screenfull.request(findDOMNode(this.refs.player));
  };

  muteAudio = () => {
    this.setState({
      muted: !this.state.muted
    });
  };

  controlVideo = () => {
    this.setState({
      pauseVideos: !this.state.pauseVideos
    });
  };

  componentWillUnmount() {
    window && window.removeEventListener("scroll", this.onScroll);
    this.setState({ _isMounted: false });
  }

  /**
   * For Looping the same video again.
   */
  onEnd = () => {
    this.setState({
      loop: this.state.loop === 3 ? 1 : ++this.state.loop,
      videoArr: Array(this.state.loop).fill(this.videoUrl)
    });
  };

  render() {
    const {
      monitoredData,
      bannerContent,
      isBannerModalVisible,
      muted,
      pauseVideos,
      updateValues
    } = this.state;

    return (
      <React.Fragment>
        <div className={`banner-responsive-wrapper`} id="home">
          <div className="container">
            <label>About PMG</label>
            <h1>Project Monitoring Group</h1>
            <div className="video-wrapper">
              <Suspense fallback={<div>Loading video player...</div>}>
                <ReactPlayer
                  url={this.videoUrl}
                  ref="player"
                  muted={muted}
                  loop={true}
                  playing={!pauseVideos}
                  onEnded={this.onEnd}
                />
              </Suspense>
              <div className="controls play-icons">
                <span
                  onClick={() => this.controlVideo()}
                  className={"play-video " + (pauseVideos ? "pause" : "")}
                >
                  play/pause
                </span>
                <span
                  onClick={this.muteAudio}
                  className={"mute-video " + (muted ? "" : "mute")}
                >
                  Mute
                </span>
                <span onClick={this.onClickFullscreen} className="full-video">
                  FullScreen
                </span>
              </div>
              <div className="black-bar" onClick={() => this.controlVideo()} />
            </div>

            <div className="banner-text-responsive">
              <div className="button-group">
                <button
                  className="btn pmg-team-btn"
                  onClick={() => this.showReadBannerModal("pmgTeam")}
                >
                  <img src={People} alt="PMG Team" />
                  PMG Team
                </button>
                <button
                  className="btn pmg-mechanism-btn"
                  onClick={() => this.showReadBannerModal("mechanism")}
                >
                  <img src={System} alt="PMG Mechanism" />
                  PMG Mechanism
                </button>
              </div>

              <p>
                The Project Monitoring Group (PMG), Invest India is an
                institutional mechanism for the expedited resolution of issues
                and regulatory bottlenecks in projects with investments upward
                &#8377; 500 Cr. in India.
                <span
                  className="read-more"
                  onClick={() => this.showReadBannerModal("aboutPmg")}
                >
                  {" "}
                  ...Read More{" "}
                </span>
              </p>
            </div>

            <div className="banner-card-responsive">
              <div className="banner-card-data">
                <div className="dashboard-graph project-monitored">
                  <div className="summary-total">
                    <b>
                      {monitoredData && monitoredData.projectMonitored ? (
                        <CountUp
                          start={updateValues}
                          end={monitoredData.projectMonitored}
                          delay={0}
                          formattingFn={n => Number(n.toFixed(1))}
                          duration={2.75}
                        >
                          {({ countUpRef }) => (
                            <div>
                              <span ref={countUpRef} />
                            </div>
                          )}
                        </CountUp>
                      ) : (
                        "0"
                      )}
                    </b>
                  </div>
                  <div className="summary-label">Projects Monitored</div>
                </div>
              </div>
              <div className="banner-card-data">
                <div className="dashboard-graph project-value color-blue">
                  <div className="summary-total">
                    <b>
                      {monitoredData && monitoredData.projectValue ? (
                        <CountUp
                          start={updateValues}
                          end={monitoredData.projectValue}
                          delay={0}
                          formattingFn={n =>
                            formatNumberOnDashBoard(
                              Number(n.toFixed(1)),
                              true,
                              true,
                              "."
                            )
                          }
                          duration={2.75}
                        >
                          {({ countUpRef }) => (
                            <React.Fragment>
                              <OverlayTrigger
                                overlay={
                                  <Tooltip className="my-tooltip-1 project-val-tooltip">
                                    &#x20B9;{" "}
                                    {monitoredData.projectValue &&
                                      parseInt(monitoredData.projectValue)}{" "}
                                    Cr.
                                  </Tooltip>
                                }
                              >
                                <div>
                                  <span ref={countUpRef} />
                                </div>
                              </OverlayTrigger>
                            </React.Fragment>
                          )}
                        </CountUp>
                      ) : (
                        "0"
                      )}
                    </b>
                  </div>
                  <div className="summary-label">Project Value</div>
                </div>
              </div>
              <div className="banner-card-data">
                <div className="dashboard-graph issue-monitored color-teal">
                  <div className="summary-total">
                    <b>
                      {monitoredData && monitoredData.issueMonitored ? (
                        <CountUp
                          start={updateValues}
                          end={monitoredData.issueMonitored}
                          delay={0}
                          useEasing={true}
                          formattingFn={n => Number(n.toFixed(1))}
                          duration={2.75}
                        >
                          {({ countUpRef }) => (
                            <div>
                              <span ref={countUpRef} />
                            </div>
                          )}
                        </CountUp>
                      ) : (
                        "0"
                      )}
                    </b>
                  </div>
                  <div className="summary-label">Issues Monitored</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {bannerContent === "aboutPmg" ? (
          <PmgModal
            show={isBannerModalVisible}
            closeModal={this.closeReadBannerModal}
          />
        ) : null}
        {bannerContent === "mechanism" ? (
          <PmgMechanismModal
            show={isBannerModalVisible}
            closeModal={this.closeReadBannerModal}
          />
        ) : null}
        {bannerContent === "pmgTeam" ? (
          <PmgTeamModal
            onClose={this.closeReadBannerModal}
            className={"team-gallery-container-responsive"}
          />
        ) : null}
      </React.Fragment>
    );
  }
}

export default BannerResponsive;
